import { useState, useContext, useEffect, useMemo } from "react";
import { GlobalContext } from "../../context/GlobalContext";
import Pagination from "../../components/Pagination";
import Search from "../../components/Search";
import PaymentsTable from "./PaymentsTable";

const Payments = () => {
  const { paymentsData, filterPaymentsData, setPaymentsFilterData } = useContext(GlobalContext);

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(10);
  const [selectedIds, setSelectedIds] = useState([]);
  const [fileCount, setFileCount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  const filteredData = Array.isArray(filterPaymentsData) ? filterPaymentsData : [];

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;

  const currentPosts = useMemo(
    () => filteredData.slice(indexOfFirstPost, indexOfLastPost),
    [filteredData, indexOfFirstPost, indexOfLastPost]
  );

  const howManyPages = useMemo(
    () => Math.ceil(filteredData.length / postsPerPage),
    [filteredData.length, postsPerPage]
  );

  const handleCheckboxChange = (id) => {
    setSelectedIds((prevSelected) => {
      const updated = prevSelected.includes(id)
        ? prevSelected.filter((selectedId) => selectedId !== id)
        : [...prevSelected, id];
      return updated;
    });
  };

  const handleSelectAll = () => {
    const currentPageIds = currentPosts.map(item => item.id);
    const allSelected = currentPageIds.every(id => selectedIds.includes(id));

    setSelectedIds((prev) => {
      return allSelected
        ? prev.filter((id) => !currentPageIds.includes(id))
        : [...new Set([...prev, ...currentPageIds])];
    });
  };

  useEffect(() => {
    let total = 0;
    const selectedSet = new Set(selectedIds);
    const dataMap = new Map(filteredData.map(item => [item.id, item]));

    selectedSet.forEach(id => {
      const matched = dataMap.get(id);
      if (matched && matched.amount) {
        total += parseFloat(matched.amount);
      }
    });

    setFileCount(selectedSet.size);
    setTotalAmount(total);
  }, [selectedIds, filteredData]);

  useEffect(() => {
    setSelectedIds([]);
    setFileCount(0);
    setTotalAmount(0);
  }, [filterPaymentsData]);

  return (
    <>
      <div className="container mb-5">
        <div className="mb-1 mt-2">
          <div className="row">
            <div className="col-md-6">
              <Search data={paymentsData} setFilterData={setPaymentsFilterData} />
            </div>
            <div className="col-md-6 mt-2">
              <div>
                <span className="border bg-primary text-white mx-3 p-2 link_text">
                  File: {fileCount}
                </span>
                <span className="border bg-primary text-white p-2 link_text">
                  Amount: ₹{totalAmount.toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div>
          {currentPosts.length > 0 ? (
            <PaymentsTable
              currentPosts={currentPosts}
              handleCheckboxChange={handleCheckboxChange}
              selectedIds={selectedIds}
              handleSelectAll={handleSelectAll}
            />
          ) : (
            <table className="table table-bordered mt-2 border-gray-300">
              <tbody>
                <tr>
                  <td className="border border-gray-300 py-3 text-xl text-center" colSpan="8">
                    No Data available or Amount is null
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>

      <div className="text-md-right">
        <div className="d-flex justify-content-between">
          <div className="ml-5">
            <label htmlFor="">Jump to</label>
            <select
              className="mx-2"
              style={{ width: "50px", height: "30px" }}
              value={postsPerPage}
              onChange={(e) => {
                setPostsPerPage(parseInt(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={10}>10</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
            </select>
            <span>Page {currentPage} of {howManyPages}</span>
          </div>
          <div className="mx-5 mb-5">
            <Pagination pages={howManyPages} setCurrentPage={setCurrentPage} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Payments;
